[
  {
    "id": "GET-E8-L305-001",
    "module": "Getalbegrip",
    "difficulty": 305,
    "question": "In een klas zitten 25 leerlingen. 40% heeft een bril. Hoeveel leerlingen hebben een bril?",
    "options": [
      "10",
      "8",
      "12",
      "5"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten_sommen",
    "familyId": "GET-PROC-BEREKENEN",
    "explanation": "10% is 2,5. 40% is 4 $\\times$ 2,5 = 10. Of: 40% = $\\frac{2}{5}$. $\\frac{1}{5}$ van 25 is 5. $\\frac{2}{5}$ is 10.",
    "distractorExplanations": {
      "1": "Je rekende waarschijnlijk met 30% in plaats van 40%. 30% van 25 is 7,5 ≈ 8.",
      "2": "Je rekende met 50% (de helft) in plaats van 40%. De helft van 25 is 12,5.",
      "3": "Dit is 20% van 25. 40% is het dubbele daarvan."
    }
  },
  {
    "id": "GET-E8-L305-002",
    "module": "Getalbegrip",
    "difficulty": 305,
    "question": "Reken uit: 1000 : 0,01 =",
    "options": [
      "100.000",
      "10.000",
      "100",
      "10"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kommagetallen",
    "subSkill": "delen_klein",
    "familyId": "GET-DELEN-KOMMA",
    "explanation": "Delen door 0,01 is hetzelfde als vermenigvuldigen met 100. 1000 $\\times$ 100 = 100.000.",
    "distractorExplanations": {
      "1": "Je vermenigvuldigde met 10 in plaats van met 100. Delen door 0,01 schuift de komma 2 plaatsen.",
      "2": "Je deelde door 10 in plaats van door 0,01. Delen door een klein getal maakt het antwoord juist groter.",
      "3": "Je deelde door 100 in plaats van door 0,01. Onthoud: delen door 0,01 = keer 100."
    }
  },
  {
    "id": "GET-E8-L305-003",
    "module": "Getalbegrip",
    "difficulty": 305,
    "question": "Welk getal ligt precies tussen $\\frac{1}{3}$ en $\\frac{1}{2}$?",
    "options": [
      "$\\frac{5}{12}$",
      "$\\frac{1}{4}$",
      "$\\frac{2}{5}$",
      "$\\frac{4}{12}$"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_midden",
    "familyId": "GET-BREUK-VGL",
    "explanation": "Maak gelijknamig op 12. $\\frac{1}{3}$ = $\\frac{4}{12}$. $\\frac{1}{2}$ = $\\frac{6}{12}$. Tussen 4 en 6 ligt 5. Dus $\\frac{5}{12}$.",
    "distractorExplanations": {
      "1": "$\\frac{1}{4}$ = 0,25. Dat is kleiner dan $\\frac{1}{3}$ (≈ 0,33), dus het ligt er niet tussen.",
      "2": "$\\frac{2}{5}$ = 0,40. Dat ligt wel tussen 0,33 en 0,50, maar niet precies in het midden. Het midden is $\\frac{5}{12}$ ≈ 0,417.",
      "3": "$\\frac{4}{12}$ is gelijk aan $\\frac{1}{3}$. Dat is de ondergrens, niet het midden."
    }
  },
  {
    "id": "GET-E8-L305-004",
    "module": "Getalbegrip",
    "difficulty": 305,
    "question": "Reken uit: 3 + 4 $\\times$ 5 - 2 =",
    "options": [
      "21",
      "33",
      "15",
      "25"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "rekenvolgorde",
    "familyId": "GET-REKENVOLGORDE",
    "explanation": "Eerst vermenigvuldigen: 4 $\\times$ 5 = 20. Dan optellen en aftrekken: 3 + 20 - 2 = 21.",
    "distractorExplanations": {
      "1": "Je rekende van links naar rechts: (3 + 4) $\\times$ 5 - 2 = 33. Maar vermenigvuldigen gaat vóór optellen!",
      "2": "Je vergat de vermenigvuldiging voorrang te geven en rekende (3 + 4) $\\times$ (5 - 2) = 21. Dat klopt toevallig, maar de tussenstap is anders.",
      "3": "Je rekende 3 + 4 $\\times$ 5 = 23, en vergat de -2. Of je maakte een andere rekenfout."
    }
  },
  {
    "id": "GET-E8-L305-005",
    "module": "Getalbegrip",
    "difficulty": 305,
    "question": "Wat is 125% van 80?",
    "options": [
      "100",
      "120",
      "90",
      "160"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten_meer",
    "familyId": "GET-PROC-BEREKENEN",
    "explanation": "100% van 80 is 80. 25% van 80 is 20. Samen: 80 + 20 = 100. Of: 1,25 $\\times$ 80 = 100.",
    "distractorExplanations": {
      "1": "Je rekende 150% van 80 (80 + 40 = 120). Maar 125% is minder dan 150%.",
      "2": "Je rekende waarschijnlijk 112,5% of maakte een fout bij het berekenen van 25% van 80.",
      "3": "Je rekende 200% van 80 (het dubbele). 125% is maar een kwart extra, niet het dubbele."
    }
  }
]